import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { RemoveButtonStyle } from '../../../../picks/components/digital/pick-remove-button/remove-button-style';
import { BetBuilderPick } from '../../../models';

@Component({
    selector: 'bs-linear-bet-builder-content',
    templateUrl: './linear-bet-builder-content.component.html',
    styleUrls: ['./linear-bet-builder-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderContentComponent {
    @Input() picks: BetBuilderPick[];
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonStyle: RemoveButtonStyle;
}
